export default {
  modalTitle: {
    font: "400 24px 'Droid Serif'",
  },
};
